
const {ccclass, property} = cc._decorator;

@ccclass
export  class Q2ColorSliderComponent extends cc.Component {
    
    @property(cc.Sprite)
    spriteTime: cc.Sprite = null

    @property(cc.Boolean)
    clockwise: boolean = true

    @property(cc.Boolean)
    isAdd: boolean = false

    @property([cc.Color])
    colorList: cc.Color[] = []

    @property([cc.Float])
    rangeList: number[] = []

    private isDoAction:boolean[];

    protected m_lastTickSecs: number = 0
    protected m_passedTime: number = 0
    protected m_totalTime: number = 0
    
    protected m_isStart: boolean = false
    protected m_onFinish: Function = null
    protected m_onTick: Function = null

    //设置倒计时时间
    setOpTime(time:number,totalTime:number, onFinish?: Function, onTick?: Function){        
        if (totalTime <= 0) {
            this.node.active = false            
            return;
        }
        this.node.active = true
        
        this.m_totalTime = totalTime
        this.m_passedTime = totalTime - time
        this.m_lastTickSecs = this.m_passedTime
        this.m_isStart = true
        this.m_onFinish = onFinish
        this.m_onTick = onTick
        this.isDoAction = []      
        for (let index = 0; index < this.rangeList.length; index++) {
            this.isDoAction.push(true)
        }  
        
        this.setColor(this.m_passedTime);
    }

    update(delta:number){
        if (!this.m_isStart) {
            return;
        }
        this.setSpriteRange(delta);
    }

    protected setSpriteRange(delta: number){
        this.m_passedTime += delta
        if(this.m_lastTickSecs + 1 <= this.m_passedTime){
            this.m_lastTickSecs = this.m_passedTime
            this.m_onTick && this.m_onTick(this.m_totalTime - this.m_passedTime)
        }
        let range = this.m_passedTime / this.m_totalTime
        this.spriteTime.fillRange = this.calcFillRange(range)
        if(range >= 1){
            this.m_onTick && this.m_onTick(this.m_totalTime - this.m_passedTime)
            if(this.m_onFinish){
                this.m_onFinish()
            }
            this.m_isStart = false
        }
        this.colorChangeAction(this.m_passedTime);

    }

    protected calcFillRange(rate: number){
        if(this.clockwise){
            if(this.isAdd){
                return Math.max(-rate, -1)
            }else{
                return Math.max(1 - rate, 0)
            }
        }else{
            if(this.isAdd){
                return Math.min(rate, 1)
            }else{
                return Math.min(rate - 1, 0)
            }
        }        
    }


    private setColor(passTime:number){
        let node = this.spriteTime.node
        for (let index = 0; index < this.rangeList.length; index++) {
            const range = this.rangeList[index];
            if(passTime <= this.m_totalTime * range){
                node.color = this.colorList[index]
                break
            }
        }
    }

    private colorChangeAction(passTime:number){
        let node = this.spriteTime.node
        let totalTime = this.m_totalTime
        for (let index = 0; index < this.rangeList.length; index++) {
            const range = this.rangeList[index];
            if(passTime <= totalTime * range){
                if(this.isDoAction[index]){
                    let color = this.colorList[index]
                    let listTime = this.m_totalTime * range - passTime;
                    let action = cc.tintTo(listTime, color.getR(), color.getG(), color.getB());
                     node.stopAllActions();
                    node.runAction(action)
                    this.isDoAction[index] = false
                }
                break
            }
        }
       
    }
}
